import firebase from 'firebase/compat'
import { useDocumentData } from 'hooks/firebase'

export const useAdminData = () =>
  useDocumentData<{ uid: string }>(firebase.firestore().collection('admin').doc('admin'))
